export function toInitials(displayName: string): string {
  const [firstName = '', lastName = ''] = displayName.split(' ')
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`
}
